<mat-card *ngFor="let product of (products | async)">
  <h2>{{product.name}}</h2>
  <p><b>{{ 'CONFIGURATOR|Indeks:' | translate }} </b>{{product.code}}</p>
  <p><b>{{ 'CONFIGURATOR|Indeks rozszerzony:' | translate }} </b>{{product.codeExt}}</p>
  <p *ngIf="this.curLang">
    <b>{{ 'CONFIGURATOR|Nazwa:' | translate }} </b>{{product.localizedNames[this.curLang] ? product.localizedNames[this.curLang] : ''}}
  </p>
  <p *ngIf="!hiddenPrice">
    <b>{{ 'CONFIGURATOR|Cena:' | translate }} </b><s *ngIf="product.listUnitPrice && product.listUnitPrice != '0' && product.listUnitPrice !== product.unitPrice">{{product.listUnitPrice}}</s> {{product.unitPrice}}
  </p>
  <p><b>{{ 'CONFIGURATOR|Ilość:' | translate }} </b>{{product.quantity}}</p>
  <p *ngIf="product.altProductionTime !== undefined"><b>{{ 'DOOR|Czas realizacji:' | translate }} </b>{{product.altProductionTime}}</p>
  <p *ngIf="product.configuration && product.configuration.length > 0"><b>{{ 'CONFIGURATOR|Cechy:' | translate }} </b></p>
  <ul *ngIf="product.configuration && product.configuration.length > 0">
    <li *ngFor="let feature of product.configuration">
      {{feature.field}}: {{feature.value}}
    </li>
  </ul>
  <br>
</mat-card>
